<template>
  <div>
    <navigation />
    <!--    <topnav />-->
    <div class="task-container">
      <div class="task-content">
        <div class="task-info">
          <div class="taskinfo-column">
            <span>任务名：{{ task.taskName }}</span>
            <span>图片数：{{ task.imageCount }}张</span>
          </div>
          <div class="taskinfo-column">
            <span>标注方式：{{ task.taskTypeName }}</span>
            <span>已完成：{{ task.approvedCount }}张</span>
          </div>
          <div class="taskinfo-column">
            <div style="display: block;margin-bottom: 12px;">
              <span style="display: inline-block; margin: 0px;">类别：</span>
              <div id="class-name">
                <span class="class-info" style="margin: 0px;">{{ classInfoText }}</span>
                <div class="class-info">
                  <section v-for="(classes, index) of task.classifications" :key="'category' + classes.categoryId">
                    <span style="margin: 0px 6px 7px;">{{ getCateName(index) }}</span>
                    <p v-for="(cSlice, index) of classSlice(classes.classes)" :key="`cSlice${index}`">
                      <span v-for="c of cSlice" :key="`class${c.classId}`">{{ c.className }}</span>
                    </p>
                  </section>
                </div>
              </div>
            </div>
            <span>无效图片：{{ task.invalidCount }}张</span>
          </div>
        </div>
        <button id="get-result" @click="getResult()" v-if="task.taskStatus === 4">下载标注结果</button>
      </div>
      <imagelist :image-list="imageList" :task-id="taskId" :page-size="pageSize" :page-index="pageIndex" />
      <pagination
        :page-size="pageSize"
        :page-index="pageIndex"
        :item-total="itemTotal"
        @changeindex="changePageIndex"
        @changesize="changePageSize"
      />
    </div>
  </div>
</template>

<script>
import imagelist from '@/components/imagelist';
import pagination from '@/components/pagination';
import navigation from '@/components/navigation';
import topnav from '@/components/topnav';
import * as api from '@/api/api.js';
import { taskStatusMap } from '@/config';

export default {
  name: 'taskdetail',
  data() {
    return {
      pageSize: 20,
      pageIndex: 0,
      itemTotal: 0,
      task: {},
      taskId: 0,
      classifications: [],
      taskStatusMap: [],
      imageList: [],
    };
  },
  components: {
    imagelist,
    pagination,
    navigation,
    topnav,
  },
  computed: {
    classInfoText: function() {
      if (this.task && this.task.classifications && this.task.classifications[0]) {
        return this.task.classifications[0].classes.map(item => item.className).join(',');
      } else return '';
    },
  },
  mounted: function() {
    this.taskStatusMap = taskStatusMap;
    this.taskId = this.$route.params.id;
    if (this.$route.query.pageIndex) this.pageIndex = parseInt(this.$route.query.pageIndex);
    this.getTaskInfo();
    this.getImageList();
  },
  methods: {
    getCateName(index) {
      const map = ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'];
      return `${map[index]}级类别`;
    },
    classSlice(classes) {
      let res = [];
      for (let i = 0; i < Math.ceil(classes.length / 5); i++) {
        res.push(classes.slice(i * 5, i * 5 + 5));
      }
      return res;
    },
    getResult() {
      api
        .getAnnotationResult(this.taskId)
        .then(res => {
          api
            .downloadResultFile(res.data.url)
            .then(res => {
              let blob = new Blob([res.data], { type: 'application/download' });
              let objectUrl = URL.createObjectURL(blob);
              let a = document.createElement('a');
              a.download = `task-${this.taskId}.json`;
              a.href = objectUrl;
              a.click();
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    getImageList() {
      api
        .getImageList({ page: this.pageIndex, pagesize: this.pageSize }, this.taskId)
        .then(res => {
          this.imageList = res.data.images;
          this.itemTotal = res.data.imageCount;
        })
        .catch(() => {});
    },
    getTaskInfo() {
      api
        .getTaskInfo({ taskId: this.taskId })
        .then(res => {
          this.task = res.data.task;
          this.classifications = res.data.task.classifications;
        })
        .catch(() => {});
    },
    changePageIndex: function(pi) {
      this.pageIndex = pi;
      this.getImageList();
    },
    changePageSize: function(ps) {
      this.pageSize = parseInt(ps);
      this.pageIndex = 0;
      this.getImageList();
    },
  },
};
</script>
<style scoped>
section {
  display: inline-block;
  width: max-content;
  vertical-align: top;
  padding: 0px 10px;
  color: #595959;
}
section span {
  display: block;
  margin: 5px;
  padding: 5px;
}
span {
  display: inline-block;
}
button {
  padding: 10px 14px;
  margin: 0px;
  margin-left: 12px;
}
p {
  display: inline-block;
  margin: 0px 6px;
  vertical-align: top;
}
.task-content {
  margin-top: 12px;
  margin-bottom: 30px;
  position: relative;
}
.task-info {
  display: inline-block;
}
.taskinfo-column {
  display: inline-block;
  width: 200px;
  line-height: 100%;
  margin-top: 12px;
  vertical-align: top;
}
.taskinfo-column span {
  display: block;
  line-height: 100%;
  padding-right: 10px;
}
.taskinfo-column span:first-child {
  margin-bottom: 16px;
}
#class-name {
  display: inline-block;
  vertical-align: middle;
  margin: 0px;
}
span.class-info {
  display: inline-block;
  position: relative;
  text-decoration: underline;
  color: #5d89c0;
  padding: 0px;
  text-overflow: ellipsis;
  width: 128px;
  overflow: hidden;
  white-space: nowrap;
}
span.class-info:hover + div.class-info {
  visibility: visible;
}
div.class-info {
  background-color: #ffffff;
  padding: 16px 2px;
  width: max-content;
  position: absolute;
  visibility: hidden;
  z-index: 999;
  border: 1px solid #eeeeee;
  color: #5d89c0;
  box-shadow: 0px 2px 4px 0px rgba(221, 221, 221, 1);
  border-radius: 0px 0px 5px 5px;
}
div.class-info section span {
  padding: 0px 0px 5px 0px;
  margin: 0px;
}
div.class-info section span:first-child {
  padding: 0px 0px 5px 0px;
  margin: 0px;
}
#get-result {
  display: inline-block;
  position: absolute;
  bottom: 4px;
  right: 0px;
  margin: 0px;
}
</style>
